<template>
    <div class="academicLiteratureDetail">
        <!-- 顶部伸缩卡片 -->
        <HeadCard :data='response'/>
        <Tabs v-model="tabActive" scrollspy  sticky swipeable :line-width="22" @click="handleTabClick" >
          <Tab v-for="tab in tabList" :key="tab.name"  :title="tab.name" style="margin-top:0.1rem;" :id="tab.name">
              <RowCard :title='tab.name' :rows='getRows(tab)' :data='response' >
              </RowCard>
          </Tab>
        </Tabs>
        <div class="footer">
            <label>数据来源：</label>
            <div @click="handleDataSource">{{response.link}}</div>
        </div>
    </div>
</template>
<script>
import HeadCard from './headCard'
import RowCard from './rowCard'
import { HttpRequest } from 'utils'
const ROW_CARDS = ['出版信息','基础疾病','症状','患者结局','并发症']
import { NucleicAcidTestRows,
        SevereCaseRows,
        PublishedInformationRows,
        BasicDiseasesRows,
        SymptomsRows,
        ResultRows,
        ComplicationsRows,
        SignsRows,
        BaselineCharacteristicsRows,
        TreatmentInformationRows,
        DiseasePeriod } from './config'
export default {
    components:{
        HeadCard,
        RowCard,
    },
    data() {
        return {
          rowCards:ROW_CARDS,
          tabActive:0,
          response:{},
        }
    },
    computed:{
        tabList(){
            let tab = [
              {
                  name: "全文解读",
                  key:'0',
              },
               {
                  name: "出版信息",
                  key:'1'
              },
               {
                  name: "基线特征",
                  key:'2'
              },
               {
                  name: "基础疾病",
                  key:'3'
              },
               {
                  name: "症状",
                  key:'4'
              },
               {
                  name: "体征",
                  key:'5'
              },
               {
                  name: "实验室检查",
                  key:'6'
              },
               {
                  name: "胸部影像学检查",
                  key:'7'
              },
                {
                  name: "病程时间",
                  key:'8'
              },
                {
                  name: "核酸检测",
                  key:'9'
              },
                {
                  name: "重症数量",
                  key:'10'
              },
              
                 {
                  name: "治疗方案",
                  key:'11'
              },
                {
                  name: "患者结局",
                  key:'12'
              },
               {
                  name: "并发症",
                  key:'13'
              },
            ]
           JSON.stringify(this.response) !== '{}' && tab.map(obj=>{
                obj.filter = false
                let datas = this.getRows(obj)
                if (obj.name === '全文解读'){
                    if(!this.response.summary){
                        obj.filter = true
                    }
                    return 

                }
                if (obj.name === '实验室检查'){
                    obj.filter = Array.isArray(this.response.laboratory_find_display)
                    return 

                }
                if (obj.name === '胸部影像学检查'){
                    if (this.response.ct_display.length !== 0 && this.response.x_ray_display.length !== 0 ){
                         obj.filter = false
                    }
                     obj.filter = true
                     return 
                }
                let rows = datas.filter(data=>this.response[data.key])
                if (rows.length === 0){
                    console.log(obj.name,'没值',rows)
                    obj.filter = true

                }
            })
            return tab.filter(tab=>!tab.filter)
        }
    },
    created() {
        document.title = '文献详情'
        this.fetchData()
    },
    methods:{
        /**
         * @description tab click
         */
        handleTabClick(tabIndex){
            const tab = this.tabList[tabIndex]
            this.$el.scrollTop = document.getElementById(tab.name).offsetTop + 120
        },
        // 基线 实验室检查  治疗方案 
        getRows(item){
            let data = []
            switch (item.name){
                case '出版信息':
                    data = PublishedInformationRows
                    break
                case '基础疾病':
                    data = BasicDiseasesRows
                    break
                case '症状':
                    data = SymptomsRows
                    break
                case '患者结局':
                    data = ResultRows
                    break
                case '并发症':
                    data = ComplicationsRows
                    break
                case '体征':
                    data = SignsRows
                    break
                case '基线特征':
                      data = BaselineCharacteristicsRows
                      break
                case '病程时间':
                    data = DiseasePeriod
                    break
                case '重症数量':
                    data = SevereCaseRows
                    break
                case '核酸检测':
                    data = NucleicAcidTestRows
                    break
                case '治疗方案':
                    data = TreatmentInformationRows
                    break
            }
            return data
        },
        handleDataSource(){
            window.open(this.response.link);
        },
       async fetchData(){
          let response = await HttpRequest({url:'/academic/journal_study_details/',params:{order:this.$route.query.order}})
          let responseOther = await  HttpRequest({url:`/academic/journal_study/${this.$route.query.id}/`})
           this.$set(this,'response',{
               ...response[0],
               ...responseOther
           })
           this.response.case_concluded = this.response.case_concluded === 'Y' ? '有':'无'
           let gender_display_total = 0
           this.response.gender_display.map(obj=>{
               gender_display_total += Number(obj.values || 0)
           })
            this.response.gender_display.map((obj)=>{
               obj.proportion = Number((Number(obj.values) / gender_display_total * 100).toFixed(1))
           }) 
           console.log(this.response.gender_display)
        //    this.response.gender_display[0].proportion = 0
        //               this.response.gender_display[1].proportion = 100

        }
    }
}
</script>
<style lang="less" scoped>
.academicLiteratureDetail{
    width:100%;
    height: 100%;
    overflow:auto;
    .footer{
        display:flex;
        align-items: flex-start;
        padding:0.2rem 0.16rem;
        padding-top:0;
        label{
            color: #333333;
            font-size:14px;
            display:inline-block;
        }
        div{
            width: 75%;
            display:inline-block;
            word-break:break-all;
            color: #007AFF;
            cursor: pointer;
        }

    }

}
</style>
<style lang="less">
.van-tabs__content{
    background:rgba(240,240,240,1);
}
</style>